import {
  ExpectedRevenueStateTypes,
  ExpectedRevenueActionTypes,
} from "./ExpectedRevenue.type";
import { resetApiCallState } from "../Utils";

const INITIAL_STATE: ExpectedRevenueStateTypes = {
  fetchAll: resetApiCallState([]),
  fetchOne: resetApiCallState({}),
};

const ExpectedRevenueReducer = (
  state: ExpectedRevenueStateTypes = INITIAL_STATE,
  action: any
): ExpectedRevenueStateTypes => {
  switch (action.type) {
    case ExpectedRevenueActionTypes.FETCH_ALL_EXPECTED_REVENUE:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case ExpectedRevenueActionTypes.FETCH_ALL_EXPECTED_REVENUE_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case ExpectedRevenueActionTypes.FETCH_ALL_EXPECTED_REVENUE_FAILURE:
      return {
        ...state,
        fetchAll: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case ExpectedRevenueActionTypes.FETCH_ALL_EXPECTED_REVENUE_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    case ExpectedRevenueActionTypes.FETCH_ONE_EXPECTED_REVENUE:
      return {
        ...state,
        fetchOne: {
          error: null,
          payload: {},
          isPending: true,
          isSuccessful: false,
        },
      };
    case ExpectedRevenueActionTypes.FETCH_ONE_EXPECTED_REVENUE_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState({}),
      };
    case ExpectedRevenueActionTypes.FETCH_ONE_EXPECTED_REVENUE_FAILURE:
      return {
        ...state,
        fetchOne: {
          payload: {},
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case ExpectedRevenueActionTypes.FETCH_ONE_EXPECTED_REVENUE_SUCCESS:
      return {
        ...state,
        fetchOne: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    default:
      return state;
  }
};

export default ExpectedRevenueReducer;
